var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.757286 0.575233C0.952549 0.379971 1.26913 0.379971 1.46439 0.575233L9.24257 8.35341C9.43783 8.54867 9.43783 8.86525 9.24257 9.06051C9.0473 9.25578 8.73072 9.25578 8.53546 9.06051L0.757286 1.28234C0.562024 1.08708 0.562024 0.770495 0.757286 0.575233Z",
    fill: "#231F20",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24271 0.575233C9.43798 0.770495 9.43798 1.08708 9.24271 1.28234L1.46454 9.06051C1.26928 9.25578 0.952695 9.25578 0.757433 9.06051C0.562171 8.86525 0.562171 8.54867 0.757433 8.35341L8.53561 0.575233C8.73087 0.379971 9.04745 0.379971 9.24271 0.575233Z",
    fill: "#231F20",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.9a891b258ff0261928ad2973225da790.svg";
export { ForwardRef as ReactComponent };